import React, { useContext } from "react";
import CommonModal from "./CommonModal";
import { MutedText, Text } from "@src/components/Text";
import { ModalContext, ModalType } from "@src/components/modals/ModalController";
import styled from "@emotion/styled";
import { layout } from "styled-system";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { css } from "@emotion/core";
import { Box, Flex } from "@src/components/Boxes";
import SignupForm from "./SignupForm";
import Translate from "../translation/Translate";
import { logEvent as le } from "@src/utils/logClient";

const Link = styled.a`
  line-height: 18px;
  font-family: proxima-nova, "Helvetica Neue", Helvetica, Arial, sans-serif;
  word-break: keep-all;
  white-space: nowrap;
  font-weight: 600;

  text-decoration: none;
  cursor: pointer;
  &:hover,
  &:focus {
    text-decoration: none;
    color: #00bcf2;
  }

  ${layout}
`;

const ModalTitle = styled("h3")`
  font-size: 36px;
  font-weight: 800;
  margin: 18px 0;
  line-height: 40px;
  text-align: center;
`;

const logEvent = function (eventName) {
  return le({
    eventName: eventName,
    eventValue: "domain_email_signup_overlay_variant",
  });
};

const SchoolLeaderSignupModal = (props) => {
  const data = useStaticQuery(graphql`
    query {
      badge: file(name: { eq: "school_leader_badge" }) {
        childImageSharp {
          fixed(width: 88, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `);

  const { badge } = data;

  const modalContext = useContext(ModalContext);

  function showLoginModal() {
    modalContext.showModal(ModalType.SchoolLeaderLogin);
  }

  return (
    <CommonModal noHeader {...props}>
      <Img
        fixed={badge.childImageSharp.fixed}
        loading="eager"
        css={css`
          margin: 15px 0;
        `}
      />
      <Flex flexDirection="column" alignItems="center" maxWidth={["100%", "85%"]} mx="auto">
        <ModalTitle>
          <Translate path="components.signup_teacher.ab_title_leader" />
        </ModalTitle>
        <Box>
          <Text display="inline-block">
            <Translate path="components.signup_teacher.subtitle" />
          </Text>
          <Link
            onClick={() => {
              logEvent(`web.school_leader.user_signup.signup_form.login_instead.tap`);
              showLoginModal();
            }}
            display="inline-block"
          >
            <MutedText display="inline-block" ml="5px" fontSize={[2, 2, 3]}>
              <Translate path="components.signup_teacher.log_in_here" />
            </MutedText>
          </Link>
        </Box>
        <SignupForm userType="school_leader" />
      </Flex>
    </CommonModal>
  );
};

export default SchoolLeaderSignupModal;
